import { useState } from 'react';
import { Outlet } from '@tanstack/react-router';
import { ScrollToTopButton } from '@/components/common/ScrollToTopButton';
import { SidebarInset } from '@/components/ui/sidebar';
import { usePermissionsSync } from '@/features/auth/hooks/usePermissions';
import { useMenuLabelsSync } from '@/features/menuLabels/hooks/useMenuLabels';
import { useSessionExpiredRedirect } from '@/features/auth/hooks/useSessionExpiredRedirect';
import { AppSidebar } from './AppSidebar';
import { AppHeader } from './AppHeader';
import { AppSidebarProvider } from './AppSidebarProvider';
import { AppHeaderActionsSlotContext } from './appHeaderActionsSlot';
import { AppHeaderTitleSlotContext } from './appHeaderTitleSlot';

export function AppLayout() {
  useSessionExpiredRedirect();
  usePermissionsSync();
  useMenuLabelsSync();
  const [headerTitleSlot, setHeaderTitleSlot] = useState<HTMLDivElement | null>(null);
  const [headerActionsSlot, setHeaderActionsSlot] = useState<HTMLDivElement | null>(null);

  return (
    <AppSidebarProvider>
      <AppSidebar />
      <SidebarInset className="min-w-0 bg-app-glow">
        <AppHeader titleSlotRef={setHeaderTitleSlot} actionsSlotRef={setHeaderActionsSlot} />
        <AppHeaderTitleSlotContext.Provider value={headerTitleSlot}>
          <AppHeaderActionsSlotContext.Provider value={headerActionsSlot}>
            <main className="flex flex-1 min-w-0 flex-col px-4 pt-app-gutter-top pb-4 md:px-app-gutter-x md:pb-app-gutter-y">
              <Outlet />
            </main>
          </AppHeaderActionsSlotContext.Provider>
        </AppHeaderTitleSlotContext.Provider>
        <ScrollToTopButton />
      </SidebarInset>
    </AppSidebarProvider>
  );
}
